import { render, staticRenderFns } from "./BulletPoint.vue?vue&type=template&id=3bb87740"
import script from "./BulletPoint.vue?vue&type=script&lang=ts"
export * from "./BulletPoint.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports